<template>
    <v-card width="380" class="d-inline-block text-center pa-1" flat>
      <v-card :flat="$vuetify.breakpoint.mobile" class="mb-4 text-left">
        <v-form ref="form" @submit.prevent="createAccount()" lazy-validation>
          <v-container class="pa-4">
            <v-row>
              <v-col class="text-h5">Create account</v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Full name" v-model="input.name" outlined dense autofocus
                              validate-on-blur :rules="[required('name')]"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field label="Email address" v-model="input.email" outlined dense
                              :error-messages="errorEmail"
                              validate-on-blur :rules="[required('email address'),email]"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field label="Password" v-model="input.password" outlined dense
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                          :error-messages="errorPassword"
                          validate-on-blur :rules="[required('password'),password]"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col class="text-caption text-center">
                By clicking AGREE &  CREATE ACCOUNT, you agree to the Purtrak
                <router-link to="/terms">Terms of use</router-link>
                and
                <router-link to="/privacy">Privacy policy</router-link>
              </v-col>
            </v-row>

            <v-row >
              <v-col>
                <v-btn color="primary" large width="100%" type="submit">AGREE AND CREATE ACCOUNT</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider/>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <google-sign-in :query="query" sign-up @googleIdToken="createAccount($event)"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
      Already have an account? <v-btn text color="primary" :to="{path:'/authorize', query}">Sign in</v-btn>
    </v-card>
</template>

<script>
import axios from 'axios'
import GoogleSignIn from '@/components/GoogleSignIn'

export default {
  name: 'CreateAccount',
  components: {GoogleSignIn},
  data() {
    return {
      input: {name:'',email:'', password:''},
      showPassword: false,

      required(label) {
        return value => !!value?.trim() || `Please enter your ${label}`
      },
      email: v => {
        const pattern = /^((\s)*[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(\s*,\s*|\s*$))*$/i
        return !v || pattern.test(v) || `Your e-mail address doesn't look right`;
      },
      password: v => {
        // eslint-disable-next-line no-useless-escape
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
        return pattern.test(v) || 'Min length 8 with at least one capital letter, a number and a special character';
      },
      errorEmail: null,
      errorPassword: null
    }
  },
  computed: {
    query() {
      return this.$route.query;
    }
  },
  methods: {
    async createAccount(googleIdToken) {
      if (!googleIdToken && !this.$refs.form.validate())
        return;

      this.errorEmail = null;
      this.errorPassword = null;

      const response = await axios.post('/_authorize', {googleIdToken, ...this.input, create:true, query:this.query});
      if (response.data.error) {
        if (response.data.error === 'invalid_email') {
          this.errorEmail = response.data.error_message;
          return;
        }
        if (response.data.error === 'invalid_password') {
          this.errorPassword = response.data.error_message;
          return;
        }
        if (response.data.redirect_uri)
          location.href = `${response.data.redirect_uri}/?error=${response.data.error}&error_message=${response.data.error_message}`;
        else
          this.$router.push({name:'Error',params:{error:response.data.error_message}});
      }
      else
        location.href = `${response.data.redirect_uri}/?code=${response.data.code}&state=${response.data.state}`;
    }
  }
}
</script>
